<a-avatar [user]="user$ | async"></a-avatar>